// client/src/services/importsApi.js
// Migration imports (Roadmap Phase 5.3): members from a CSV, past events and
// attendees from Eventbrite, import history + undo. Server:
// routes/importRoutes.js at /api/imports/:tenant (owners / admins), and
// routes/integrations/eventbriteRoutes.js for the Eventbrite connection.

const BASE_URL = process.env.REACT_APP_BASE_URL?.replace(/\/$/, '') || '';

async function request(method, url, body) {
  const res = await fetch(`${BASE_URL}${url}`, {
    method,
    credentials: 'include',
    headers: body !== undefined ? { 'Content-Type': 'application/json' } : {},
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.message || data.error || `${res.status} ${res.statusText}`);
    err.response = { status: res.status, data };
    throw err;
  }
  return data;
}

const base = (tenantId) => `/api/imports/${Number(tenantId)}`;

export function errorText(err, fallback) {
  return err?.response?.data?.message || err?.response?.data?.error || fallback;
}

export const getImportsOverview = (tenantId) => request('GET', `${base(tenantId)}/overview`);
export const memberTemplateUrl = (tenantId) => `${BASE_URL}${base(tenantId)}/members/template`;
export const previewMembers = (tenantId, csv) => request('POST', `${base(tenantId)}/members/preview`, { csv });
export const checkMembers = (tenantId, csv, mapping) => request('POST', `${base(tenantId)}/members/check`, { csv, mapping });
export const commitMembers = (tenantId, body) => request('POST', `${base(tenantId)}/members/commit`, body);
export const getImport = (tenantId, id) => request('GET', `${base(tenantId)}/history/${Number(id)}`);
export const undoImport = (tenantId, id) => request('POST', `${base(tenantId)}/history/${Number(id)}/undo`);
export function listEventbriteEvents(tenantId, { orgId, continuation } = {}) {
  const qs = new URLSearchParams();
  if (orgId) qs.set('orgId', orgId);
  if (continuation) qs.set('continuation', continuation);
  const s = qs.toString();
  return request('GET', `${base(tenantId)}/eventbrite/events${s ? `?${s}` : ''}`);
}
export const startEventbriteImport = (tenantId, body) => request('POST', `${base(tenantId)}/eventbrite/import`, body);
export const eventbriteLoginUrl = (tenantId) => `${BASE_URL}/api/integrations/eventbrite/login?tenantId=${Number(tenantId)}`;
export const disconnectEventbrite = (tenantId) => request('DELETE', `/api/integrations/eventbrite/${Number(tenantId)}/connection`);
